import { render, staticRenderFns } from "./receive-payment.vue?vue&type=template&id=8f65b536&scoped=true"
import script from "./receive-payment.vue?vue&type=script&lang=ts"
export * from "./receive-payment.vue?vue&type=script&lang=ts"
import style0 from "./receive-payment.vue?vue&type=style&index=0&id=8f65b536&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f65b536",
  null
  
)

export default component.exports